"use strict";

exports.__esModule = true;
exports.default = void 0;
var spacing = {
  s1: '8px',
  s2: '16px',
  s3: '24px',
  s4: '32px',
  s5: '40px',
  s6: '48px',
  s7: '56px',
  s8: '64px',
  s9: '72px',
  s10: '80px',
  s11: '88px',
  s12: '96px',
  s13: '104px',
  s14: '112px'
};
/** @component */

var _default = spacing;
exports.default = _default;